import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PortalProveedorService } from '../../../services/api.services';

@Component({
  selector: 'app-falta-material',
  templateUrl: './falta-material.component.html',
  styleUrls: ['./falta-material.component.scss'],
})
export class FaltaMaterialComponent implements OnInit {

  @Input() isModal: boolean;
  commentToSend = '';
  operatorIdSelected: number;

  constructor(private modalCtrl: ModalController,
              private portalProveedorService: PortalProveedorService) { }

  ngOnInit() {
    this.operatorIdSelected = this.portalProveedorService.getOperatorSel();
  }

  enviar() {
    this.modalCtrl.dismiss(
      {
        commentToSend: this.commentToSend,
        operatorIdSelected: this.operatorIdSelected
      }
    );
  }

}
